const SvgApplications = () => {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9683_40931)">
        <path
          d="M6.25 0.5C5.1017 0.5 4.15285 1.38331 4.02539 2.5H2.25C1.01625 2.5 0 3.51625 0 4.75V18.25C0 19.4838 1.01625 20.5 2.25 20.5H13.75C14.9838 20.5 16 19.4838 16 18.25V4.75C16 3.51625 14.9838 2.5 13.75 2.5H11.9746C11.8471 1.38331 10.8983 0.5 9.75 0.5H6.25ZM6.25 2H9.75C10.1732 2 10.5 2.32675 10.5 2.75C10.5 3.17325 10.1732 3.5 9.75 3.5H6.25C5.82675 3.5 5.5 3.17325 5.5 2.75C5.5 2.32675 5.82675 2 6.25 2ZM2.25 4H4.38477C4.79062 4.60095 5.47736 5 6.25 5H9.75C10.5226 5 11.2094 4.60095 11.6152 4H13.75C14.1732 4 14.5 4.32675 14.5 4.75V18.25C14.5 18.6732 14.1732 19 13.75 19H2.25C1.82675 19 1.5 18.6732 1.5 18.25V4.75C1.5 4.32675 1.82675 4 2.25 4Z"
          className="fill-current"
        />
      </g>
      <defs>
        <clipPath id="clip0_9683_40931">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgApplications;
